import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";

export default function ScanResultPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === undefined) return;
    if (!user) return;
    api.get("/business/me")
      .then(() => navigate("/dashboard", { replace: true }))
      .catch(() => navigate("/business-profile", { replace: true }));
  }, [user, navigate]);

  if (user === undefined || user) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="scan-result-loading">Loading&hellip;</div>;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="scan-result-gate-page">
      <SEO title="Your Scan Is Complete | A8A" description="Create your free A8A account to see your business diagnostic results." noindex />
      <div className="max-w-md text-center space-y-5">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Scan Complete</p>
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tight text-foreground leading-tight" data-testid="scan-result-gate-heading">
          Create a free account to see your results
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          It takes about 60 seconds. A8A uses a few extra details about your business to turn your
          answers into a full, benchmarked report — not just a generic score.
        </p>
        <Button size="lg" className="w-full h-12 text-base" onClick={() => navigate("/register")} data-testid="scan-result-register-button">
          Create Free Account
        </Button>
        <p className="text-sm text-muted-foreground">
          Already have an account? <Link to="/login" className="text-accent underline" data-testid="scan-result-login-link">Log in</Link>
        </p>
      </div>
    </div>
  );
}
